import React, { useState } from 'react';
import { Stack, Typography } from '@mui/material';
import { useFilePlayerContext } from '../FilePlayerContext';
import { useGetFilePlayerOverviewQuery } from 'app/api/assetApi';
import { FileSortButton } from './FileSortButton';
import { FileMasterCheckbox } from './FileMasterCheckBox';
import { FileToggleViewButton } from './FileToggleViewButton';
import { FileGroupPanel } from './FileGroupPanel';
import { FilesPanel } from './FilesPanel';
import { FileListStateShape } from '../hooks/useFileListState';
import { GROUPBY_DATE, GROUPBY_ADVISOR } from '../filePlayerConstants';

const getOverviewLabel = (groupBy, currentView) => {
  if (currentView !== 'all') return '';
  if (!groupBy) return 'All Files';
  return `All | By ${groupBy === GROUPBY_DATE ? 'Date' : 'Flirt'}`;
};

export const FilesTab = ({ allFilesState }) => {
  const { groupBy, currentView } = useFilePlayerContext();

  const [cursors, setCursors] = useState({ date: null, advisor_login: null });

  const queryByGroup = {
    date: useGetFilePlayerOverviewQuery(
      { groupBy: GROUPBY_DATE, after: cursors.date, pageSize: 20 },
      { skip: groupBy !== GROUPBY_DATE },
    ),
    advisor_login: useGetFilePlayerOverviewQuery(
      { groupBy: GROUPBY_ADVISOR, after: cursors.advisor_login, pageSize: 20 },
      { skip: groupBy !== GROUPBY_ADVISOR },
    ),
  };

  const queryResult = queryByGroup[groupBy];

  // console.log('[FilesTab] render', {
  //   groupBy,
  //   items: queryResult?.data?.items,
  // });

  const onLoadMore = () => {
    if (queryResult?.data?.nextCursor) {
      // update the cursor for the current group
      setCursors((prev) => ({
        ...prev,
        [groupBy]: queryResult.data.nextCursor,
      }));
    }
  };

  const isGroupedView = currentView === 'all' && !!groupBy;
  const isAllFilesFlatView = currentView === 'all' && !groupBy;

  return (
    <Stack spacing={2} mt={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" alignItems="center" spacing={1}>
          {isAllFilesFlatView && <FileMasterCheckbox fileListState={allFilesState} />}
          <Typography variant="body1" fontWeight="medium">
            {getOverviewLabel(groupBy, currentView)}
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1}>
          {isAllFilesFlatView && (
            <FileToggleViewButton
              listView={allFilesState.listView}
              setListView={allFilesState.setListView}
            />
          )}
          <FileSortButton />
        </Stack>
      </Stack>

      {isGroupedView ? (
        <FileGroupPanel
          key={groupBy}
          queryResult={queryResult}
          onLoadMore={onLoadMore}
          groupBy={groupBy}
        />
      ) : (
        <FilesPanel fileListState={allFilesState} />
      )}
    </Stack>
  );
};

FilesTab.propTypes = {
  allFilesState: FileListStateShape.isRequired,
};
